import { MantineSize } from '@mantine/core';
import { ThemeIcon } from 'src/design/atoms/ThemeIcon';
import { Tooltip } from 'src/design/atoms/Tooltip';
import { IconChartBar } from '@tabler/icons-react';
import React from 'react';
import { WbsTreeData } from 'src/routes/Jobs/WBS/components/types';

export interface IProgressManagedIndicatorProps {
  node: WbsTreeData;
  size?: MantineSize;
}

/** Blue chart icon marking a WBS node whose progress/quantity is managed by a linked design model; renders nothing when not progress-managed. */
export const ProgressManagedIndicator: React.FC<
  IProgressManagedIndicatorProps
> = ({ size = 'sm', node }) => {
  if (!node.progressManaged) return null;

  return (
    <Tooltip label="Progress managed by design model" withArrow>
      <ThemeIcon color="blue" size={size} variant="light">
        <IconChartBar />
      </ThemeIcon>
    </Tooltip>
  );
};
